<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I need help placing a new order / General Questions</h1>
			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './../components/BaseNavPage';
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "GeneralQuestions",

		components: {
			BaseNavLinks,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			return {
				links: [
					{
						to: '/course_doesnt_have_book',
						caption: 'My course doesn’t have a book',
						enabled: this.$globs['institute_info']['id'] != undefined
					},
					{
						to: '/redeem_voucher',
						caption: `How do I redeem a ${this.$globs['institute_info']['voucher_name']}?`
					},
					{
						to: '/how_to_find_book',
						caption: 'How do I find the books I need to buy?'
					},
					{
						to: '/error_when_pay',
						caption: 'I had an error when trying to pay'
					},
					{
						to: '/forms_of_payment',
						caption: 'What forms of payment can I use?'
					},
					{
						to: '/supplemental_materials',
						caption: "Do Used books & eBooks come with supplemental materials<br>such as Access Codes, CD-ROMs, or DVDs?"
					},
					{
						to: '/why_options_arent_showing',
						caption: "Why aren't any rental, ebooks, used etc. options showing?"
					},
					{
						to: '/cant_log_in',
						caption: 'I can’t log in to my account / I don’t know my password',
						enabled: !this.$globs['customer_info'] || this.$globs['customer_info']['reg_order'] !== '0',
					},
					{
						to: '/cant_ship_to_campus',
						caption: 'Can I ship to campus?',
						enabled: this.$globs['institute_info']['id'] != undefined
					},
					{
						url: '/returns',
						caption: 'I’d like to make a return'
					},
				]
			}
		},

		mounted() {
			const self = this;
		}
	}
</script>

<style scoped>

</style>